"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _bikeStationAvailabilities = _interopRequireDefault(require("../bike-station-availabilities"));
var _bikeStationHistoryChart = _interopRequireDefault(require("../bike-station-history-chart"));
var _button = require("../button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BikeStationPopup({
  theme,
  bikeStation: _bikeStation,
  search,
  enqueueSnackbar,
  onUpdated,
  onSearchUpdated,
  onClose
}) {
  const [bikeStation, setBikeStation] = (0, _react.useState)(_bikeStation);
  const [history, setHistory] = (0, _react.useState)();
  function handleLeaveFromHere() {
    search?.wayPoints.splice(0, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  function handleGoThere() {
    search?.wayPoints.splice(-1, 1, bikeStation.location.clone());
    onSearchUpdated?.();
  }
  const {
    label,
    location
  } = bikeStation;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(StyledHeader, null, /*#__PURE__*/_react.default.createElement(StyledTitle, {
    title: label,
    variant: "subtitle1"
  }, label), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, location.address)), /*#__PURE__*/_react.default.createElement(StyledContent, null, /*#__PURE__*/_react.default.createElement(_bikeStationAvailabilities.default, {
    bikeStation: bikeStation,
    enqueueSnackbar: enqueueSnackbar,
    onUpdated: onUpdated,
    setBikeStation: setBikeStation,
    setHistory: setHistory
  }), /*#__PURE__*/_react.default.createElement(_bikeStationHistoryChart.default, {
    bikeStation: bikeStation,
    history: history
  })), search && /*#__PURE__*/_react.default.createElement(StyledActions, null, /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "inherit",
    onClick: handleLeaveFromHere,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.leave_from_here"
  })), /*#__PURE__*/_react.default.createElement(_button.Button, {
    color: "inherit",
    onClick: handleGoThere,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.go_there"
  })))));
}
const Wrapper = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 400px);
`;
const CloseButtonWrapper = _styledComponents.styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledHeader = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 16px 58px 8px 16px;
`;
const StyledTitle = (0, _styledComponents.styled)(_Typography2.default)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledContent = _styledComponents.styled.div`
  border-top: 1px solid #ddd;
  flex-shrink: 1;
  overflow-y: auto;
  padding: 16px 24px;
`;
const StyledActions = _styledComponents.styled.div`
  align-items: center;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  height: 48px;
  padding: 0 16px;

  button {
    margin-left: 8px;
  }
`;
var _default = exports.default = BikeStationPopup;